"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
const SUCCESS_RESPONSE_CODES = ['success', 'inProgress'];
function messageIdSocket(createSocket) {
    const socket = createSocket();
    let currentMessageId = 0;
    return Object.assign(Object.assign({}, socket), { send(request, timeoutDelay = 30000) {
            var _a;
            return __asyncGenerator(this, arguments, function* send_1() {
                const messageId = `${currentMessageId++}`;
                const messageWithId = Object.assign(Object.assign({}, request), { messageIdentifier: {
                        resourceType: 'MessageIdentifier',
                        messageId,
                    } });
                const responses = socket.watch();
                try {
                    socket.send(messageWithId);
                    const timeoutPromise = new Promise((_resolve, reject) => setTimeout(() => {
                        reject(new errors_1.CirrusTimeoutError(`Cirrus request ${request.messageType} ${messageId} timed out.`, request));
                    }, timeoutDelay));
                    while (true) {
                        const { value } = yield __await(Promise.race([responses.next(), timeoutPromise]));
                        if (value &&
                            (value === null || value === void 0 ? void 0 : value.messageType) !== 'SubscribeData' &&
                            ((_a = value === null || value === void 0 ? void 0 : value.messageIdentifier) === null || _a === void 0 ? void 0 : _a.messageId) === messageId) {
                            yield yield __await(value);
                        }
                    }
                }
                finally {
                    responses.return();
                }
            });
        },
        request(request, timeoutDelay) {
            var e_1, _a;
            var _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    for (var _d = __asyncValues(this.send(request, timeoutDelay)), _e; _e = yield _d.next(), !_e.done;) {
                        const response = _e.value;
                        const responseCode = (_b = response.responseCode) === null || _b === void 0 ? void 0 : _b.name;
                        if (!SUCCESS_RESPONSE_CODES.includes(responseCode)) {
                            throw new errors_1.CirrusError(`Cirrus request with id "${(_c = response.messageIdentifier) === null || _c === void 0 ? void 0 : _c.messageId}" of type "${request.messageType}" failed with code "${responseCode}".`, request, response);
                        }
                        return response;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) yield _a.call(_d);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                throw new Error('The socket seems to have broken somehow internally. I did not expect to get an error here.');
            });
        } });
}
exports.default = messageIdSocket;
//# sourceMappingURL=messageIdSocket.js.map